<template>
  <div class="user-page">
    <div class="page">
      <div class="menu-box">
        <el-menu default-active="1-1" class="el-menu-vertical-demo" router>
          <el-menu-item-group title="我的企业">
            <!-- <el-menu-item disabled index="1-1" v-if="!$store.state.user.userType == 3">企业信息</el-menu-item> -->
            <el-menu-item index="/user/manage">账号管理</el-menu-item>
            <el-menu-item index="/user/childManage" v-if="!$store.state.user.parentId">子用户管理</el-menu-item>
            <el-menu-item index="/user/addressManage">收货地址管理</el-menu-item>
          </el-menu-item-group>
          <el-divider></el-divider>
          <el-menu-item-group title="订单管理">
            <el-menu-item index="/user/order">我的订单</el-menu-item>
            <el-menu-item index="/user/orderAudit">订单审核</el-menu-item>
            <el-menu-item disabled index="2-3">定制需求</el-menu-item>
          </el-menu-item-group>
          <el-divider></el-divider>
          <el-menu-item-group title="售后服务">
            <el-menu-item disabled index="3-1">售后申请单</el-menu-item>
          </el-menu-item-group>
        </el-menu>
      </div>
      <router-view style="flex: 1"></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: "UserHome",
  data() {
    return {
      timeStep: 1,
      recordList: [
        "http://39.99.175.196/kufeng-admin/305168990424416197e668be3cca4cc6.jpg",
        "http://39.99.175.196/kufeng-admin/cb1a92b069b843248b05fc55276a80a6.jpg",
        "http://39.99.175.196/kufeng-admin/305168990424416197e668be3cca4cc6.jpg",
        "http://39.99.175.196/kufeng-admin/cb1a92b069b843248b05fc55276a80a6.jpg"
      ]
    };
  },
  methods: {
    goOrder() {
      this.$router.push('/user/order')
    }
  },
  mounted() {
  }
};
</script>

<style scoped>
.menu-box >>> .el-menu-item-group__title {
  font-size: 16px;
  font-weight: bold;
  color: #000;
  line-height: 32px;
}
.menu-box >>> .el-menu-item {
  height: 32px;
  line-height: 32px;
}
.menu-box >>> .el-menu{background-color: #eee}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='less'>
.user-page {
  width: 80%;
  margin: auto;
  min-height: calc(100vh - 360px);
  background: #eee;
  .page {
    width: 100%;
    display: flex;
  }
  .menu-box {
    width: 140px;
  }
  .account-box {
    flex: 1;
    margin: 20px;
    .bg {
      background: #fff;
    }
    .account-info > div:last-child {
      padding: 10px 0;
      display: flex;
      flex-wrap: wrap;
      > span {
        margin-left: 25%;
        width: 200px;
        line-height: 40px;
        font-weight: bold;
      }
    }

    .order-btn-box {
      display: flex;
      align-items: flex-end;
      > div {
        line-height: 40px;
        flex: 1;
        text-align: center;
      }
    }

    .pie-chart {
      height: 240px;
    }

    .focus-content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      > div {
        padding: 12px 20px;
        line-height: 32px;
      }
    }
    .browse-record {
      display: flex;
      justify-content: space-between;
      align-items: center;
      > div {
        padding: 12px 20px;
        line-height: 32px;
        img {
          width: 100%;
        }
      }
    }
  }

  .flex {
    display: flex;
  }
}
</style>
